




















































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Watch } from 'vue-property-decorator';
import {
  BarChart2Icon,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  GridIcon,
  UserIcon,
  XIcon,
  DownloadIcon,
} from 'vue-feather-icons';
import { DateFilter, IProduct, ITag, IUser, PolicyFilter, PolicyStatus } from 'admiral-core';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { PreferencesAction } from '@/store/PreferencesModule';
import DateFilterComponent from '@/components/filters/DateFilter.vue';
import UserFilterComponent from '@/components/filters/UserFilter.vue';
import ProductFilterComponent from '@/components/filters/ProductFilter.vue';
import PolicyStatusFilterComponent from '@/components/filters/PolicyStatusFilter.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import TagFilterComponent from '@/components/filters/TagFilter.vue';
import { Util } from '@/utils/Util';
import BusinessYearFilter from '@/components/filters/BusinessYearFilter.vue';
import { PolicyApi } from '@/services/PolicyApi';
import { PermissionMixin } from '@/mixins/PermissionMixin';

@Component({
  components: {
    BusinessYearFilter,
    TagSelect,
    HorizontalPolicyStatusSelect,
    'date-filter': DateFilterComponent,
    'user-filter': UserFilterComponent,
    'product-filter': ProductFilterComponent,
    'policy-status-filter': PolicyStatusFilterComponent,
    'tag-filter': TagFilterComponent,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    BarChart2Icon,
    DownloadIcon,
    UserIcon,
    XIcon,
    GridIcon,
  },
})
export default class PolicyFilterComponent extends mixins(FilterMixin, PermissionMixin) {
  filter: PolicyFilter = {
    businessYear: new Date().getFullYear(),
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
    status: [],
    tags: [],
  };

  get isDefaultFilter() {
    return (
      this.filter.dateFilter === DateFilter.ALL &&
      this.filter.users?.length === 0 &&
      this.filter.products?.length === 0 &&
      this.filter.tags?.length === 0 &&
      this.filter.businessYear === new Date().getFullYear()

      // this.filter.status?.length === 2 &&
      // this.filter.status?.includes(PolicyStatus.OPEN) &&
      // this.filter.status?.includes(PolicyStatus.SUBMITTED)
    );
  }

  updateDateFilter(filter: { dateFilter: DateFilter; from: number; to: number }) {
    this.filter.dateFilter = filter.dateFilter;
    if (filter.from) {
      this.filter.from = filter.from;
    }
    if (filter.to) {
      this.filter.to = filter.to;
    }

    this.updateFilter();
  }
  updatePolicyStatusFilter(status: PolicyStatus[]) {
    this.filter.status = status;
    this.updateFilter();
  }

  updateUserFilter(users: IUser[]) {
    this.filter.users = [...users];
    this.updateFilter();
  }

  toggleShowChartView() {
    this.filter.uiHideChartView = !this.filter.uiHideChartView;
    this.updateFilter();
  }

  updateProductFilter(products: IProduct[]) {
    this.filter.products = [...products];
    this.updateFilter();
  }

  updateTagsFilter(tags: ITag[]) {
    this.filter.tags = [...tags];
    this.updateFilter();
  }

  updateBusinessYearFilter(year: number) {
    this.filter.businessYear = year;
    this.updateFilter();
  }

  resetFilter() {
    this.filter = {
      businessYear: new Date().getFullYear(),
      dateFilter: DateFilter.ALL,
      products: [],
      users: [],
      tags: [],
      status: [PolicyStatus.OPEN, PolicyStatus.SUBMITTED],
    };
    this.filter.users = [];
    this.filter.dateFilter = DateFilter.ALL;
    this.updateFilter();
    this.$root.$emit('reset-policy-filter');
  }

  get policyFilter() {
    return this.$store.getters['PreferencesModule/getPolicyFilter'];
  }

  @Watch('policyFilter')
  async onPolicyFilterChanged(policyFilter: PolicyFilter) {
    this.filter = policyFilter;
  }

  async mounted() {
    try {
      this.filter = await this.$store.getters['PreferencesModule/getPolicyFilter'];
    } catch (e) {
      this.$toastr.e('Beim Abrufen der Produkte und Mitarbeiter ist etwas schiefgelaufen.');
    }

    this.filter.businessYear = this.filter.businessYear || new Date().getFullYear();

    this.$root.$on('update-policy-filter', async () => {
      await this.updateFilter();
    });
  }

  async updateFilter() {
    if (this.filter.users && !Array.isArray(this.filter.users)) {
      this.filter.users = [this.filter.users];
    }

    // TODO: workaround (get status from buttons first)
    const filter = (await this.$store.getters['PreferencesModule/getPolicyFilter']) as PolicyFilter;
    this.filter.status = filter.status;

    this.filter.businessYear = this.filter.businessYear || new Date().getFullYear();

    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.setPolicyFilter}`,
      this.filter,
    );

    // workaround
    this.$root.$emit('change-policy-filter');

    this.close();
  }

  selectedFilterString() {
    let str = '';

    if (!this.isDefaultFilter || this.filter.dateFilter !== DateFilter.ALL) {
      str += this.dateFilterNames(this.filter.dateFilter!) + ', ';
    }

    if (this.filter.businessYear) {
      str += 'GJ ' + this.filter.businessYear + ', ';
    }

    if (this.filter.products && this.filter.products.length > 0) {
      str += this.filter.products[0].name + ', ';
    }
    if (this.filter.users && this.filter.users.length > 0) {
      str += this.filter.users[0].firstname + ', ';
    }
    if (this.filter.tags && this.filter.tags.length > 0) {
      str += '#' + this.filter.tags[0].name + ', ';
    }
    // if (!this.isDefaultFilter) {
    //   this.filter.status?.forEach((status: PolicyStatus) => {
    //     str += this.statusFilterNames(status) + ', ';
    //   });
    // }

    return str.substr(0, str.length - 2);
  }

  get filterFromStore(): PolicyFilter {
    return this.$store.getters['PreferencesModule/getPolicyFilter'] as PolicyFilter;
  }

  onOver() {
    (this.$refs as any).dropdown.visible = true;
  }
  onLeave(evt: Event) {
    (this.$refs as any).dropdown.visible = false;
  }

  get isMobile() {
    return Util.isMobile();
  }

  async handleExportPolicies() {
    try {
      let filter = this.policyFilter;
      this.$Progress.start();
      if (!filter) {
        filter = {
          agency: this.user.agency,
        };
      }

      if (!filter.agency) {
        filter.agency = this.user.agency;
      }

      const response = await PolicyApi.exportPolicies({
        ...filter,
        // @ts-ignore
        users: filter.users?.length > 0 ? filter.users : undefined,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });

      const date = new Date().toISOString().split('T')[0];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Anbahnungen_${date}.csv`);
      document.body.appendChild(link);
      link.click();
    } catch (e) {
      this.$toastr.e(
        'Beim Exportieren der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.$Progress.finish();
      throw e;
    }
    this.$Progress.finish();
  }
}
